import { render, staticRenderFns } from "./relateNewHouseDialog.vue?vue&type=template&id=2a8c223f&scoped=true"
import script from "./relateNewHouseDialog.vue?vue&type=script&lang=js"
export * from "./relateNewHouseDialog.vue?vue&type=script&lang=js"
import style0 from "./relateNewHouseDialog.vue?vue&type=style&index=0&id=2a8c223f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c223f",
  null
  
)

export default component.exports